import styled from 'styled-components';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Grid } from '../Grid';

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};

    ${mediaQuery.tabletPortrait`
      margin-top: ${spacing(6)} ;
      margin-bottom: ${spacing(8)};
    `}
  }
`;

export const Heading = styled.h1`
  ${fonts.headingXLarge}
  margin: 0;
`;

export const Subhead = styled.p`
  ${fonts.paragraph}
  margin: ${spacing(2)} 0 0;

  ${mediaQuery.tabletPortrait`
    margin: ${spacing(2)} 0 0;
  `}
`;
